import React from "react";
import { Tooltip } from "antd";
import styles from "./style.module.scss";

const MainTabs = ({ navigationData, activeMainTab, onTabClick }) => {
  return (
    <div className={styles.mainTabs}>
      {navigationData.map((tab) => {
        const btn = (
          <button
            key={tab.id}
            className={`${styles.mainTab} ${
              activeMainTab === tab.id ? styles.active : ""
            } ${tab.disabled ? styles.disabled : ""}`}
            onClick={() => !tab.disabled && onTabClick(tab.id)}
          >
            {tab.label}
            <span className={styles.indicator} />
          </button>
        );

        return tab.tooltip ? (
          <Tooltip key={tab.id} title={tab.tooltip}>
            <span className={styles.tooltipWrapper}>{btn}</span>
          </Tooltip>
        ) : btn;
      })}
    </div>
  );
};

export default MainTabs;
